export class SelectedService {
    serviceId: string;
}
